import { render, staticRenderFns } from "./ClientHelpCenter.vue?vue&type=template&id=6b1c0157"
import script from "./ClientHelpCenter.vue?vue&type=script&lang=js"
export * from "./ClientHelpCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports